<template>
  <div class="whatsapp-button">
    <TooltipWidget :color="`secondary`" tip="WhatsApp" left>
      <v-btn
        height="48px"
        :href="link"
        target="_blank"
        class="
          gradiente-bg
          px-0 px-sm-4
          text-none
          elevation-0
          btn-whatsapp-widget
        "
        rounded
        width="auto"
        fab
      >
        <v-icon size="29" color="secondary">fab fa-whatsapp</v-icon>
        <span class="ml-2 font-weight-bold text-body-1 d-none d-sm-block"
          >WhatsApp</span
        >
      </v-btn>
    </TooltipWidget>
  </div>
</template>

<script>
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";
import TooltipWidget from "./TooltipWidget.vue";

export default {
  props: {
    tel: {
      type: String,
      required: true,
    },
  },
  computed: {
    link() {
      return getWhatsappLinkFromPhone(this.tel);
    },
  },
  components: {
    TooltipWidget,
  },
};
</script>

<style>
@media (max-width: 600px) {
  .btn-whatsapp-widget {
    aspect-ratio: 1/1;
  }
}
.whatsapp-button {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 99999;
}
</style>
